module.exports = __webpack_public_path__ + "img/brand-17.7d2ef1cb.png";